import dayjs from 'dayjs';

import { Host } from '../hooks';

export const getUniqueSortedBookings = (
  selectedHosts?: Array<Host>,
  hosts?: Array<Host>
): { name: string; time: string }[] => {
  const dialogData = selectedHosts?.flatMap((host) => {
    if (host.bookings.length !== 0 && !host.bookings[0].byClient) {
      const nearestBooking = host.bookings[0];
      const bookingTime = dayjs(nearestBooking.from).format();
      const nearestBookingHostsIds = nearestBooking?.hosts;
      const hostsInBooking = nearestBookingHostsIds.map((hostId) => {
        return hosts?.find((h) => h.id === hostId);
      });

      return hostsInBooking.map((hostInBooking) => {
        return {
          name: hostInBooking?.alias as string,
          time: bookingTime,
        };
      });
    }
    return [];
  });

  const currentTime = dayjs().format('HH:mm');
  const todayBookings = dialogData?.filter((b) => b.time >= currentTime) || [];
  const nextDayBookings = dialogData?.filter((b) => b.time < currentTime) || [];

  todayBookings.sort((a, b) => a.time.localeCompare(b.time));
  nextDayBookings.sort((a, b) => a.time.localeCompare(b.time));

  const sortedDialogData = [...todayBookings, ...nextDayBookings];

  return sortedDialogData.filter(
    (item, index, self) =>
      index ===
      self.findIndex((i) => i.name === item.name && i.time === item.time)
  );
};
